module.exports = __webpack_public_path__ + "img/title_2.07e18939.png";